import { render, staticRenderFns } from "./newXq.vue?vue&type=template&id=01bbe930&scoped=true"
import script from "./newXq.vue?vue&type=script&lang=js"
export * from "./newXq.vue?vue&type=script&lang=js"
import style0 from "./newXq.vue?vue&type=style&index=0&id=01bbe930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bbe930",
  null
  
)

export default component.exports